/** A phone number as WhatsApp digits with country code ("96891234567"), or null.
 *  Local numbers typed without + / 00 get the company's default country code (settings.default_cc)
 *  when they are 8 digits (Oman, Gulf) — from almuzn-tracker waPhone, with the country code made a setting. */
export function waPhone(raw: unknown, defaultCc = ""): string | null {
  let d = String(raw ?? "").replace(/^whatsapp:/i, "").split(/[\/,;]/)[0].replace(/[^\d+]/g, "");
  if (d.startsWith("+")) d = d.slice(1);
  else if (d.startsWith("00")) d = d.slice(2);
  else if (defaultCc && /^\d{7,9}$/.test(d)) d = defaultCc + d.replace(/^0/, "");
  return /^\d{10,15}$/.test(d) ? d : null;
}
export const phoneKey = (waId: string) => waId.slice(-8);
